// eslint-disable-next-line eag/no-external-date-time-format-functions -- It is intended to have custom format here
import {format} from 'date-fns';

export function getIsoStringWithoutTimezone(input: Date): string {
  return `${format(input, "yyyy-MM-dd'T'HH:mm:ss.SSS")}Z`;
}
